import React from 'react';
import ReactDOM from 'react-dom';
import { Main } from '@sections/components';

const renderSections = (element) => {
  const data = $(element).data('sections-data');

  ReactDOM.render(
    <Main {...data} />,
    element
  );
};

$('html').on('consumer.dependencies.loaded', () => {
  const sectionsElement = document.getElementById('sections-content');
  if (sectionsElement) renderSections(sectionsElement);
});
